import {Router} from '@angular/router';
import {AppSettingsService} from '../services/app-settings.service';
import {Label, Scenario, StaticMethods} from './GeneralModels';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';

export class BasicInformation {
  constructor(public stateCode: string, public cityCode: string, public insurance: string) {
  }
}

export class PersianKeyValue {
  constructor(private value: string, private persianLabel: string) {
  }

  getValue() {
    return this.value;
  }

  getPersianLabel() {
    return this.persianLabel;
  }
}

export class HealthRequest {
  constructor(
    // tslint:disable-next-line:variable-name
    private _birthDay: string,
    // tslint:disable-next-line:variable-name
    private _basicInsurance: string,
    // tslint:disable-next-line:variable-name
    private _gender: string,
    // tslint:disable-next-line:variable-name
    private _relationship: string,
    // tslint:disable-next-line:variable-name
    private _weight: number,
    // tslint:disable-next-line:variable-name
    private _height: number) {
  }

  birthday(): string {
    return this._birthDay;
  }

  basicInsurance() {
    return this._basicInsurance;
  }

  gender(): string {
    return this._gender;
  }

  weight(): number {
    return this._weight;
  }

  height(): number {
    return this._height;
  }

  relation(): string {
    return this._relationship;
  }
}

export class SubRequestDetails {
  private currentStep: string;
  private displayArray: any = {};
  private mainLabel = '';
  private secondaryLabel = '';

  constructor(private subRequestID: number, private age: number, private gender: string, private relation: string,
              private Weight: number, private Height: number, private requiredBasicInsurance: boolean,
              private DateOfCreation: number, private FormsSubmission: boolean,
              private doctorReplyStatus: string, private paid: boolean, private NationalCard: boolean,
              private BirthCertificate: boolean, private InsuranceCard: boolean, scenario: Scenario, private insuranceReleased: boolean,
              private healthOffer?: number, private testStatus?: Label[], private MainRequest?: boolean) {
    if (!doctorReplyStatus) {
      this.doctorReplyStatus = 'NO_REPLY';
    }
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.setDisplayArray();
  }

  getDisplayArray() {
    return this.displayArray;
  }

  setDisplayArray() {
    this.displayArray.age = this.age;
    this.displayArray.gender = this.gender;
    if (this.healthOffer) {
      this.displayArray.offer = this.healthOffer;
    } else {
      this.displayArray.offer = false;
    }
    this.displayArray.FormsSubmission = this.FormsSubmission;
    this.displayArray.paid_label = this.paid + '_payment';
    this.displayArray.NationalCard = this.NationalCard + '_FILE_STATUS';
    this.displayArray.BirthCertificate = this.BirthCertificate + '_FILE_STATUS';
    if (this.requiredBasicInsurance) {
      this.displayArray.InsuranceCard = this.InsuranceCard + '_FILE_STATUS';
    }
    if(this.doctorReplyStatus === "REJECT"){
      this.currentStep = "لغو"
    }
    if (this.doctorReplyStatus) {
      this.displayArray.doctorReplyStatus = this.doctorReplyStatus;
    }
    if (this.testStatus && this.testStatus.length) {
      this.testStatus.forEach(test => {
        this.displayArray[test.getPersianLabel()] = false + '_TEST_STATUS';
      });
    }
    this.displayArray.status = this.getStep();
  }

  getSubRequestID() {
    return this.subRequestID;
  }

  getAge() {
    return this.age;
  }

  getGender() {
    return this.gender;
  }

  getRelation() {
    return this.relation;
  }

  getWeight() {
    return this.Weight;
  }

  getHeight() {
    return this.Height;
  }

  getRequiredBasicInsurance() {
    return this.requiredBasicInsurance;
  }

  getDateOfCreation() {
    return this.DateOfCreation;
  }

  getFormsSubmission() {
    return this.FormsSubmission;
  }

  getDoctorReplyStatus() {
    return this.doctorReplyStatus;
  }

  getPaid() {
    return this.paid;
  }

  getNationalCard() {
    return this.NationalCard;
  }

  getBirthCertificate() {
    return this.BirthCertificate;
  }

  getInsuranceCard() {
    return this.InsuranceCard;
  }

  getHealthOffer() {
    return this.healthOffer;
  }

  getMainRequest() {
    return this.MainRequest;
  }

  getTestStatus() {
    return this.testStatus;
  }

  setMainLabel(label: string) {
    this.mainLabel = label;
  }

  setSecondaryLabel(label: string) {
    this.secondaryLabel = label;
  }

  getMaiLabel() {
    return this.mainLabel;
  }

  getSecondaryLabel() {
    return this.secondaryLabel;
  }

  getStep(): string {
    return this.currentStep;
  }

  private checkStepStatus = (step: string, object: SubRequestDetails): boolean => {
    console.log(object)
    switch (step) {
      case HealthScenarios.offerSelected:
        return !object.healthOffer !== true;
      case HealthScenarios.fileUploaded:
        return object.NationalCard && object.BirthCertificate && (object.InsuranceCard || !object.requiredBasicInsurance);
      case HealthScenarios.formSubmitted:
        return object.FormsSubmission;
      case HealthScenarios.doctorReplied:
        return object.getDoctorReplyStatus() === 'ACCEPT' || (object.getDoctorReplyStatus() === 'TEST' && object.testStatus.length > 0);
      case HealthScenarios.paid:
        return object.paid;
      case HealthScenarios.testUploaded:
        return object.testRequired();
      case HealthScenarios.rejected:
        return object.doctorReplyStatus !== 'REJECT';
      case HealthScenarios.waitingForRelease:
        return object.insuranceReleased;
      case HealthScenarios.insuranceReleased:
        return !object.insuranceReleased;
    }
  }

  private testRequired(): boolean {
    if (this.doctorReplyStatus === 'TEST') {
      return !this.testStatus.length;
    } else {
      return true;
    }
  }

  getFileType(translationsService: AppSettingsService): Label {
    if (this.currentStep === HealthScenarios.fileUploaded) {
      return !this.NationalCard ? new Label(HealthScenarios.nationalCard,
        translationsService.translateEnglish(HealthScenarios.nationalCard))
        // tslint:disable-next-line:max-line-length
        : !this.BirthCertificate ? new Label(HealthScenarios.birthCertificate,
          translationsService.translateEnglish(HealthScenarios.birthCertificate))
          // tslint:disable-next-line:max-line-length
          : !this.InsuranceCard ? new Label(HealthScenarios.insuranceCard,
            translationsService.translateEnglish(HealthScenarios.insuranceCard)) : null;
    }
    if (this.currentStep === HealthScenarios.testUploaded) {
      return this.testStatus[0];
    }
  }
}

export class HealthRequestDetails {
  constructor(private newInsurance?: boolean, private readonly subRequests?: SubRequestDetails[], private RequestID?: number) {
    if (!subRequests) {
      this.subRequests = [];
    }
  }

  getNewInsurance() {
    return this.newInsurance;
  }

  getSubRequestsDetails(): SubRequestDetails[] {
    return this.subRequests;
  }

  getRequestID() {
    return this.RequestID;
  }
}

export class HealthMethods {
  static setHealthRequestDetail(details: any, scenario: Scenario, requestID?: number) {
    const subRequestsDetails: SubRequestDetails[] = [];
    if (!details.RequestStatus) {
      details.RequestStatus = details.subRequests;
    }
    details.RequestStatus.forEach((item: any) => {
      const testStatusList = [];
      if (item.testStatus && item.testStatus.length) {
        item.testStatus.forEach((test) => {
          testStatusList[testStatusList.length] = new Label(test.englishLabel, test.persianLabel);
        });
      }
      subRequestsDetails[subRequestsDetails.length] = new SubRequestDetails(
        item.subRequestID,
        item.age,
        item.gender,
        item.relation,
        item.Weight,
        item.Height,
        item.requiredBasicInsurance,
        item.DateOfCreation,
        item.FormsSubmission,
        item.doctorReplyStatus,
        item.paid,
        item.NationalCard,
        item.BirthCertificate,
        item.InsuranceCard,
        scenario,
        details.newInsurance,
        item.HealthOffer,
        testStatusList,
        item.MainRequest,
      );
    });
    let id: number;
    if (!requestID) {
      id = details.RequestID;
    } else {
      id = requestID;
    }
    return new HealthRequestDetails(details.newInsurance, subRequestsDetails, id);
  }
}

export class HealthOffer {
  private readonly persianKeyValueValue: PersianKeyValue[];
  private name: string;
  private companyName: string;
  private offerID: number;
  private totalPrice: PersianKeyValue;
  private originalPrice: PersianKeyValue;
  private discountsList: string[];

  constructor(object: any[], private appSettingsService: AppSettingsService, translation: any[]) {
    this.persianKeyValueValue = [];
    Object.entries(object).forEach(
      ([key, value]: [string, any]) => {
        switch (key) {
          case 'name':
            this.name = value;
            break;
          case 'totalPrice':
            this.totalPrice = new PersianKeyValue(this.appSettingsService.translateEnglish(key), StaticMethods.numberWithCommas(value));
            break;
          case 'originalCost':
            this.originalPrice = new PersianKeyValue(this.appSettingsService.translateEnglish(key), StaticMethods.numberWithCommas(value));
            break;
          case 'discountsList':
            this.discountsList = value;
            break;
          case 'OfferID':
            this.offerID = value;
            break;
          default:
            if (key === 'CompanyName') {
              this.companyName = value;
            }
            const index = this.persianKeyValueValue.length;
            this.persianKeyValueValue[index] = new PersianKeyValue(
              this.appSettingsService.translateEnglish(key, translation), StaticMethods.numberWithCommas(value));
            break;
        }
      });
  }

  getList(): PersianKeyValue[] {
    return this.persianKeyValueValue;
  }

  getOfferName(): string {
    return this.name;
  }

  getTotalPrice(): PersianKeyValue {
    return this.totalPrice;
  }

  getOriginalPrice(): PersianKeyValue {
    return this.originalPrice ? this.originalPrice : this.totalPrice;
  }

  getDiscountsList(): string[] {
    return this.discountsList;
  }

  getOfferID() {
    return this.offerID;
  }

  getCompanyName(): string {
    return this.companyName;
  }
}

export class CompanyOffer {
  public companies: any;
  constructor(offers: HealthOffer[]) {
    this.companies = {};
    offers.forEach(offer => {
      if (!this.companies[offer.getCompanyName()]) {
        this.companies[offer.getCompanyName()] = [];
      }
      this.companies[offer.getCompanyName()][this.companies[offer.getCompanyName()].length] = offer;
    });
  }
}

export class HealthScenarios {
  static readonly fileUploaded = 'fileUploaded';
  static readonly nationalCard = 'NationalCard';
  static readonly birthCertificate = 'BirthCertificate';
  static readonly insuranceCard = 'InsuranceCard';
  static readonly formSubmitted = 'formSubmitted';
  static readonly doctorReplied = 'doctorReplied';
  static readonly paid = 'paid';
  static readonly testUploaded = 'testUploaded';
  static readonly offerSelected = 'offerSelected';
  static readonly rejected = 'rejected';
  static readonly healthMenTestUploaded = 'HealthMenTest';
  static readonly healthGeneralTestUploaded = 'HealthGeneralTest';
  static readonly healthDiabeticTestUploaded = 'HealthDiabeticTest';
  static readonly healthThyroidTestUploaded = 'HealthThyroidTest';
  static readonly healthOtherTestsUploaded = 'HealthOtherTests';
  static readonly WrongInfo = 'WrongInfo';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly insuranceReleased = 'insuranceReleased';
  static scenarios = {
    MULTIPLE: new Scenario([
      HealthScenarios.offerSelected,
      HealthScenarios.fileUploaded,
      HealthScenarios.formSubmitted,
      HealthScenarios.doctorReplied,
      HealthScenarios.testUploaded,
      HealthScenarios.paid,
      HealthScenarios.rejected,
      HealthScenarios.waitingForRelease,
      HealthScenarios.insuranceReleased
    ]),
    SP: new Scenario([
      HealthScenarios.offerSelected,
      HealthScenarios.fileUploaded,
      HealthScenarios.formSubmitted,
      HealthScenarios.doctorReplied,
      HealthScenarios.testUploaded,
      HealthScenarios.paid,
      HealthScenarios.waitingForRelease,
      HealthScenarios.insuranceReleased,
      HealthScenarios.rejected
    ]),
    AP: new Scenario([
      HealthScenarios.offerSelected,
      HealthScenarios.fileUploaded,
      HealthScenarios.formSubmitted,
      HealthScenarios.doctorReplied,
      HealthScenarios.testUploaded,
      HealthScenarios.paid,
      HealthScenarios.waitingForRelease,
      HealthScenarios.insuranceReleased,
      HealthScenarios.rejected
    ]),
    B2B: new Scenario([
      HealthScenarios.offerSelected,
      HealthScenarios.fileUploaded,
      HealthScenarios.formSubmitted,
      HealthScenarios.paid,
      HealthScenarios.doctorReplied,
      HealthScenarios.testUploaded,
      HealthScenarios.waitingForRelease,
      HealthScenarios.insuranceReleased,
      HealthScenarios.rejected
    ]),
  };

  constructor() {
  }

  static getMultipleScenario(): Scenario {
    return this.scenarios.MULTIPLE;
  }

  static getSPScenario(): Scenario {
    return this.scenarios.SP;
  }

  static getAPScenario(): Scenario {
    return this.scenarios.AP;
  }

  static getB2BScenario(): Scenario {
    return this.scenarios.B2B;
  }
}
